import { PlatformLocation } from '@angular/common';
import { AfterContentInit, AfterViewInit, Component, HostListener, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import Konva from 'konva';
import { Rect } from 'konva/lib/shapes/Rect';
import * as _ from 'lodash';
import { DndDropEvent } from 'ngx-drag-drop';
import { db } from 'src/app/db/db';
import { AreaMap } from 'src/app/domain/area-map';
import { ECardinality } from 'src/app/domain/enums/cardinality';
import { ELifeCycleStatus } from 'src/app/domain/enums/life-cycle-status';
import { MeasureLingette } from 'src/app/domain/Lingette/measure-lingette';
import { MeasureMassif } from 'src/app/domain/Massif/measure-massif';
import { ENavigationRoute } from 'src/app/model/enum/navigation-route';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { StringTool } from 'src/app/tools/mapping/string.tool';
import { PathUtility } from 'src/app/tools/path-utility';
import { LoadingTask } from 'src/app/tools/ui/loading-task';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';
import { StringConverter } from 'src/app/tools/ui/string-converter';

let ng: DrawingMapToolComponent;

@Component({
    selector: 'app-drawing-map-tool',
    templateUrl: './drawing-map-tool.component.html',
    styleUrls: ['./drawing-map-tool.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DrawingMapToolComponent implements OnInit, AfterContentInit {

    public MAX_LENGTH = 200;

    private areaMapLocalId!: number;
    private interventionCode!: number;
    private zpCode?: string;
    private isDepose?: boolean;

    private GAX_I = 'GAX_I';
    private GAX_J = 'GAX_J';
    private GAX_K = 'GAX_K';
    private IMG_WIND = 'IMG-WIND';
    public SelectedColor = 'black';
    public ZoneNameForTitle = '';

    public Model: AreaMap = new AreaMap();
    public IsCreation = false;
    // public AvailableMeasures: MeasureReferenceNameColor[] = [];

    // MeasuresForSampling: MeasureReferenceNameColorDto[] = [];
    public HasWindThumbnail = false;

    public WindOrientation?: number;
    public SamplerOrientation?: number;

    public stage!: Konva.Stage;
    private layer!: Konva.Layer;
    private tempLayer!: Konva.Layer;
    private newLine: any[] = [];
    private selectedShape?: Konva.Shape;

    private rectDefaultWidth = 150;
    private rectDefaultHeight = 50;

    sceneWidth = 1000;
    sceneHeight = 1000;
    // public width = window.innerWidth - 10;
    // public height = window.innerHeight - 200;

    private eventClickMustBeStopped = false;

    private rectOriginX: number = 0;
    private rectOriginY: number = 0;

    ValidRequiredMaxLegnth = new UntypedFormControl('', [Validators.required, Validators.maxLength(this.MAX_LENGTH)]);
    ValidMaxLegnth = new UntypedFormControl('', [Validators.maxLength(this.MAX_LENGTH)]);
    ValidLegendMaxLegnth = new UntypedFormControl('', [Validators.maxLength(this.MAX_LENGTH)]);

    /** List of Lingette or Massif measures associated with the current intervention 
     * But there can only be one type of measure (Lingette or Massif) at a time.
    */
    LingetteOrMassifList: (MeasureLingette | MeasureMassif)[] = [];
    get IsProcess() {
        return this.isDepose === undefined
    }


    get HasLingetteOrMassif() {
        return this.LingetteOrMassifList.length > 0;
    }

    get AvailableLingetteOrMassif() {
        return this.LingetteOrMassifList.filter(x => x.Status === ELifeCycleStatus.CompletedAndNotPositioned);
    }
    SelectedLingetteOrMassifPosition?: string;

    constructor(private route: ActivatedRoute,
        private platformLocation: PlatformLocation,
        private router: Router,
        private dialog: MatDialog,
        private snackBar: MatSnackBar,
        private loadingTask: LoadingTask,
        private coreData: CoreData) { }

    @HostListener('document:keyup', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        if ((event.target as HTMLElement).tagName === 'BODY') { // Prevent event coming from the 2 inputs at the bottom of the page

            if (this.selectedShape === undefined) {
                return;
            }
            if (event.key === 'Enter') {
                this.newLine = [];
            } else if (event.key === 'Delete') {
                (this.stage.find('Transformer') as any).destroy();
                if (this.selectedShape.name() === 'll' || !StringTool.isNotNullOrEmpty(this.selectedShape.name())) {
                    this.selectedShape.destroy();
                } else if (this.selectedShape instanceof Konva.Image) {
                    if (this.selectedShape.name() === 'background') {
                        this.selectedShape.destroy();
                    } else {
                        this.selectedShape.image(undefined);
                        this.selectedShape.width(0);
                        this.selectedShape.height(0);
                        // this.selectedShape.used(false);
                        this.selectedShape.draw();
                    }
                } else {
                    const uniqueCode = this.getMagicStringFromText(this.selectedShape.name());
                    const letter = _.truncate(uniqueCode, '{ separator:[\d]}');
                    const repetition = uniqueCode.substring((uniqueCode + letter).length);
                    this.cleanZombies(letter, +repetition, +repetition);
                    // this.AvailableMeasures.push(this.Model.Measures.find(x => this.getMagicString(x) === this.getMagicStringFromText(this.selectedShape!.name())));
                    // _.remove(this.Model.Measures, this.AvailableMeasures.find(x => this.getMagicString(x) === this.getMagicStringFromText(this.selectedShape!.name())));
                }
                this.stage.draw();
            }
            this.selectedShape = undefined;
        }
    }

    ngOnInit(): void {
        ng = this;
    }

    async ngAfterContentInit() {

        this.ValidRequiredMaxLegnth.markAsTouched();
        this.ValidMaxLegnth.markAsTouched();

        this.initStage();

        this.areaMapLocalId = Number(this.route.snapshot.params?.['areaMapId']);
        this.interventionCode = Number(this.route.snapshot.params?.['interventionCode']);
        this.zpCode = this.route.snapshot.params?.['zpCode'];
        if (this.route.snapshot.params?.['isDepose']) {
            this.isDepose = Boolean(JSON.parse(this.route.snapshot.params?.['isDepose']));
        }

        if (this.zpCode) {
            this.addReferenceCassette();
        } else {
            // Load lingette via intervention code
            this.LingetteOrMassifList = (await db.getInterventionByCode(this.interventionCode)).MesureLingetteList;
            this.LingetteOrMassifList = this.LingetteOrMassifList.concat((await db.getInterventionByCode(this.interventionCode)).MesureMassifList);
            this.LingetteOrMassifList.forEach(x => {
                if (x.Status === ELifeCycleStatus.CompletedAndPositionedNotSaved) {
                    x.Status = ELifeCycleStatus.CompletedAndNotPositioned;
                    this.updateMeasureStatus(x, ELifeCycleStatus.CompletedAndNotPositioned);
                }
            });
        }

        const am: AreaMap = await db.getAreaMapById(this.areaMapLocalId);

        this.loadStage(am.JsonContent!, am.BackgroundPicture!);
        this.clearCancelledMeasure();

        // Adjust proportion
        // console.log(this.stage.width() / this.width)
        // this.stage.scaleX(this.stage.width() / this.width);
        // this.stage.scaleY(this.stage.height() / this.height);
        this.fitStageIntoParentContainer();
    }

    loadStage(jsonStage: string, backgroundPicture: string) {

        this.stage = Konva.Node.create(jsonStage, 'container');
        // Restor default size
        // this.stage.width(this.stage.width() / this.stage.scaleX());
        // this.stage.height(this.stage.height() / this.stage.scaleY());
        // this.stage.scale({ x: 1, y: 1 });
        // this.stage.draw();

        if (this.stage.children)
            this.layer = this.stage.children[0];

        this.setDragStartEvent();
        this.setDragEndEvent();

        // TODO Retrieve emdCode from JSON
        if (backgroundPicture) {
            this.setBackgroundImage(backgroundPicture);
        }

        const img = ng.stage.findOne((node: Konva.Shape) => node instanceof Konva.Image && node.name() === ng.IMG_WIND);
        if (img) {
            this.HasWindThumbnail = true;
            this.addWindThumbnail();
        }
        const imgHachure = ng.stage.findOne((node: Konva.Shape) => node instanceof Konva.Image && node.name() === 'Move-Arrow');
        if (imgHachure) {
            this.attachImageToHachure()
        }
        const imgWind = ng.stage.findOne((node: Konva.Shape) => node instanceof Konva.Image && node.name() === 'Wind-Arrow');
        if (imgWind) {
            this.attachImageToWind()
        }

        // this.displayCircleAndRectForMeasures(this.Model.Measures);
        this.setLinesTransformer();
    }

    getColorByLingetteOrMassifStatus(mL: MeasureLingette | MeasureMassif) {
        switch (mL.Status) {
            case ELifeCycleStatus.NotCompletedAndNotPositioned:
                return 'default !important';
            case ELifeCycleStatus.CompletedAndNotPositioned:
            case ELifeCycleStatus.CompletedAndPositionedNotSaved:
                return '#E59EDD !important';
            case ELifeCycleStatus.CompletedAndPositioned:
                return '#B4E5A2 !important';
        }
    }

    fitStageIntoParentContainer() {
        var container: any = document.querySelector('#stage-parent');

        // now we need to fit stage into parent container
        var containerWidth = container.offsetWidth;
        console.log(containerWidth);
        // but we also make the full scene visible
        // so we need to scale all objects on canvas
        var scale = containerWidth / this.sceneWidth;

        this.stage.width(this.sceneWidth * scale);
        this.stage.height(this.sceneHeight * scale);
        this.stage.scale({ x: scale, y: scale });
    }

    omitSpecialChar(event: any) {
        var k;
        k = event.charCode;  //         k = event.keyCode;  (Both can be used)
        return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57) || (k >= 44 && k <= 46)
            || (k >= 224 && k <= 239) || k === 244 || k === 246 || k === 249 || k === 39 || k === 43 || (k >= 251 && k <= 252));
    }

    async addReferenceCassette() {
        let zone;
        if (this.isDepose !== undefined)
            zone = await db.getZoneByCodeWithChildren(this.zpCode!, this.isDepose);
        const process = await db.getProcessMeasureByCodeWithChildren(this.zpCode!);

        if (zone) {

            zone.ZoneMesureList.forEach(x => {
                let text: Konva.Text = ng.stage.findOne((node: Konva.Shape) => node.name() === x.Code);
                if (text) {
                    let newString = text.text().includes('\n') ? text.text().slice(0, text.text().indexOf('\n')) : text.text();

                    if (text && x.Cassette.Reference && !text.text().includes(x.Cassette.Reference)) {
                        // let newString = text.text().slice(0, text.text().lastIndexOf('\n'));
                        newString = newString + `\n${x.Cassette.Reference}`;
                        text.text(newString);
                        const rect = text.parent?.findOne((shape: Konva.Shape) => shape instanceof Konva.Rect);
                        if (rect) {
                            // Text size + a little bit of margins
                            rect.width(text.width() + 5);
                            rect.height(text.height() + 10);
                            rect.clearCache();
                            rect.draw();
                        }
                    }

                    if (x.IsCancelled) {
                        this.addToolTipForCancelledMeasure(text.parent?.findOne((shape: Konva.Shape) => shape instanceof Konva.Rect)!);
                    }
                }
            });
        }

        if (process) {
            const text: Konva.Text = ng.stage.findOne((node: Konva.Shape) => node.name() === process.Code);
            let newString = text.text().includes('\n') ? text.text().slice(0, text.text().indexOf('\n')) : text.text();

            process.ProcessOperatorList.forEach(x => {

                x.CassetteList.forEach(y => {

                    if (text && y.Reference && !text.text().includes(y.Reference)) {

                        newString = newString + `\n${y.Reference}`;
                        text.text(newString);
                        const rect = text.parent?.findOne((shape: Konva.Shape) => shape instanceof Konva.Rect);
                        if (rect) {
                            rect.width(text.width());
                            rect.height(text.height());
                            rect.clearCache();
                            rect.draw();
                        }
                    }

                })
            })
            if (process.IsCancelled) {
                this.addToolTipForCancelledMeasure(ng.stage.findOne((node: Konva.Shape) => node.name() === process.Code).parent?.findOne((shape: Konva.Shape) => shape instanceof Konva.Rect)!);
            }
        }
    }

    clearCancelledMeasure() {

        ng.stage.find((node: Konva.Shape) => node instanceof Konva.Label).forEach(x => {
            if (x) {
                x.destroy();
            }
        })
        this.stage.clearCache();
        this.stage.draw()
    }

    addToolTipForCancelledMeasure(rect: Konva.Rect) {
        const label = rect.parent?.findOne((node: Konva.Shape) => node instanceof Konva.Label)
        if (label) {
            label.destroy();
        }
        // tooltip
        var tooltip = new Konva.Label({
            x: rect.width() / 2,
            y: rect.parent?.y()! < 50 ? rect.height() + 10 : -10,
            opacity: 0.75,
        });

        tooltip.add(
            new Konva.Tag({
                fill: 'orange',
                pointerDirection: rect.parent?.y()! < 50 ? 'up' : 'down',
                pointerWidth: 10,
                pointerHeight: 10,
                lineJoin: 'round',
                shadowBlur: 10,
            })
        );

        tooltip.add(
            new Konva.Text({
                text: 'ANNULEE',
                fontFamily: 'Calibri',
                fontStyle: 'bold',
                fontSize: 24,
                padding: 5,
                fill: 'white',
            })
        );

        rect.parent?.add(tooltip);
        rect.parent?.clearCache();
        rect.parent?.draw();
    }

    // showWarningsAboutSimulationType() {
    //     if (this.coreData.IsMobile && this.Model.RequiredActions?.length > 0) {
    //         const dialogRef = this.dialog.open(ConfirmBoxDialog, { data: { message: this.Model.RequiredActions, withCancelButton: false } });
    //         dialogRef.afterClosed().subscribe(result => {

    //         });
    //     }
    // }

    initStage() {

        this.stage = new Konva.Stage({
            container: 'container',
            width: this.sceneWidth,
            height: this.sceneHeight
        });

        this.layer = new Konva.Layer();
        this.tempLayer = new Konva.Layer();

        this.stage.add(this.layer);
        this.stage.add(this.tempLayer);
    }

    getMagicStringFromText(text: string) {
        return `${text.substring(text.indexOf('-') + 1)}`;
    }

    public get CardinalityList() {
        return Object.values(ECardinality).filter(x => !isNaN(Number(x))).map((y: any) => StringConverter.getCardinalityName(y));
    }

    // handleWindThumbnail() {
    //     if (this.HasWindThumbnail) {
    //         (this.layer.find((node: Konva.Shape) => node instanceof Konva.Image && node.name() === this.IMG_WIND) as any).destroy();
    //         // this.layer.findOne(node => node instanceof Konva.Image && node.name() === this.IMG_WIND).remove();
    //         this.stage.draw();
    //     } else {
    //         this.addWindThumbnail();
    //     }
    //     this.HasWindThumbnail = !this.HasWindThumbnail;
    // }

    // handleSituationPlan() {
    //     if (this.Model.IsSituationPlan) {
    //         this.Model.Comment = null;
    //     } else {
    //         this.Model.Comment = `Pour les mesures dont l'emplacement n'a pas été défini, celui-ci sera défini par le préleveur le jour de l’intervention et reporté (si possible) sur le plan en fonction de l’emprise du chantier.`;
    //     }
    // }

    cleanZombies(letter: string, repetition: number, max = Number.MAX_SAFE_INTEGER) {
        let obj = null;
        for (let i = repetition; obj !== undefined && i <= max; i++) {
            obj = this.stage.findOne(`.l-${letter}${i}`);
            if (obj) {
                this.stage.findOne(`.gc-${letter}${i}`).destroy();
                this.stage.findOne(`.gr-${letter}${i}`).destroy();
                this.stage.findOne(`.l-${letter}${i}`).destroy();
            }
        }
    }

    setBackgroundImage(backgroundPicture: string) {

        const imageObj = new Image();
        // imageObj.setAttribute('crossOrigin', 'anonymous');
        imageObj.onload = function () {
            let x = 20;
            let y = 20;
            let scaleX = 1;
            let scaleY = 1;
            const img = ng.stage.findOne((node: Konva.Shape) => node instanceof Konva.Image && node.name() === 'background');
            if (img) { // Retrieve former position
                x = img.x();
                y = img.y();
                scaleX = img.scaleX();
                scaleY = img.scaleY();
                img.destroy();
            }

            const newImage = new Konva.Image({
                x: x,
                y: y,
                scaleX: scaleX,
                scaleY: scaleY,
                image: imageObj,
                name: 'background',
                draggable: ng.coreData.IsMobile ? false : true,
                listening: ng.coreData.IsMobile ? false : true,
            });

            const ratio = imageObj.width / imageObj.height
            if (ratio > 1) {
                newImage.width(ng.sceneWidth - 40);
                newImage.height(newImage.width() / ratio);
            } else {
                newImage.height(ng.sceneHeight - 40);
                newImage.width(newImage.height() * ratio);
            }

            // if (imageObj.width > ng.width) {
            //   newImage.width(ng.width - 40);
            // }
            // if (imageObj.height > ng.height) {
            //   newImage.height(ng.height - 40);
            // }
            ng.layer.add(newImage);
            newImage.moveToBottom();

            ng.layer.draw();
            ng.setLinesTransformer();
        };

        // TODO NEW URL FOR THE BACKGROUND BASE64 https://jsbin.com/rifazetowo/edit?html,js,output
        imageObj.src = `data:image/png;base64,${backgroundPicture}`;
    }

    click(event: any) {
        if (this.stage.getPointerPosition() === undefined) {
            if (!this.eventClickMustBeStopped) {
                (this.stage.find('Transformer') as any).destroy();
                this.stage.draw();
            }
            this.eventClickMustBeStopped = !this.eventClickMustBeStopped;
            return;
        }

        // this.newLine.push(this.stage.getRelativePointerPosition());

        // if (this.newLine.length > 1) {
        //     const line = new Konva.Line({
        //         name: 'll',
        //         points: [this.newLine[0].x, this.newLine[0].y, this.newLine[1].x, this.newLine[1].y],
        //         stroke: this.SelectedColor,
        //         strokeWidth: 5,
        //     });

        //     this.layer.add(line);
        //     this.newLine.splice(0, 1);
        //     this.layer.draw();

        //     line.on('click', function (e) {
        //         ng.putSelectionOnItem(e);
        //     });
        // }
    }

    setLinesTransformer() {
        this.stage.find((node: Konva.Shape) =>
            node instanceof Konva.Rect ||
            node instanceof Konva.Circle ||
            node instanceof Konva.Line ||
            node instanceof Konva.Text ||
            node instanceof Konva.Arrow ||
            node instanceof Konva.Image)
            .forEach((shape: any) => {
                if (ng.coreData.IsMobile) {
                    shape.on('tap', function (e: any) {
                        ng.putSelectionOnItem(e);
                        ng.eventClickMustBeStopped = true;
                    });
                } else {
                    shape.on('click', function (e: any) {
                        ng.putSelectionOnItem(e);
                        ng.eventClickMustBeStopped = true;
                    });
                }
            });
    }

    putSelectionOnItem(e: any) {


        (ng.stage.findOne('Transformer') as any)?.destroy();
        let tr = null;

        // if (e.target instanceof Konva.Text && !e.target.getName().startsWith('t')) {
        //     tr = new Konva.Transformer({
        //         nodes: [e.target],
        //         enabledAnchors: ['middle-left', 'middle-right'],
        //         // set minimum width of text
        //         boundBoxFunc: function (oldBox, newBox) {
        //             newBox.width = Math.max(30, newBox.width);
        //             return newBox;
        //         }
        //     });
        // } else 
        if (e.target instanceof Konva.Rect) {
            tr = new Konva.Transformer({
                nodes: [e.target.parent],
                enabledAnchors: ['top-left', 'top-center', 'top-right', 'middle-right', 'middle-left', 'bottom-left', 'bottom-center', 'bottom-right'],
                rotateEnabled: false,
            });

        } else if (e.target instanceof Konva.Circle) {
            if (ng.HasLingetteOrMassif) {
                ng.SelectedLingetteOrMassifPosition = e.target.parent.children.find((child: any) => child instanceof Konva.Text).getText();
            }
            tr = new Konva.Transformer({
                nodes: [e.target.parent],
                enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right'],
                rotateEnabled: false,
            });

        } else if (e.target instanceof Konva.Text) {
            if (ng.HasLingetteOrMassif) {
                ng.SelectedLingetteOrMassifPosition = e.target.parent.children.find((child: any) => child instanceof Konva.Text).getText();
            }
            tr = new Konva.Transformer({
                nodes: [e.target.parent],
                enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right'],
                rotateEnabled: false,
            });
        } // IMAGE WIND ARROW
        else if (e.target instanceof Konva.Image && e.target.getName() === 'Wind-Arrow') {
            tr = new Konva.Transformer({
                nodes: [e.target],
                enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right'],
                rotateEnabled: true
            });
        } // MOVE ARROW ZONE DE TRAVAIL HACHUREE
        else if (e.target instanceof Konva.Image && e.target.getName() === 'Move-Arrow') {
            tr = new Konva.Transformer({
                nodes: [e.target],
                enabledAnchors: ['top-left', 'top-center', 'top-right', 'middle-right', 'middle-left', 'bottom-left', 'bottom-center', 'bottom-right'],
                rotateEnabled: true
            });
        }
        else { // IMAGE BACKGROUND
            tr = new Konva.Transformer({
                nodes: [e.target],
                enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right'],
                rotateEnabled: false
            });
        }

        ng.layer.add(tr);

        if (e.target instanceof Konva.Circle) {
            // e.target.parent.add(tr);
            tr.on('transform', function () {
                ng.checkThatGroupsWithCircleStayOnTheStage(e.target.parent, e.target);
                e.target.parent.clearCache();
                e.target.parent.draw();
                const txt: Konva.Text = ng.stage.findOne('.tc-' + ng.getMagicStringFromText(e.target.getName()));
                if (txt.text().length === 1) {
                    txt.x(e.target.x() - 5 * e.target.scaleX());
                    txt.y(e.target.y() - 5 * e.target.scaleX());
                    txt.fontSize(16);
                } else {
                    txt.x(e.target.x() - 14 * e.target.scaleX());
                    txt.y(e.target.y() - 5 * e.target.scaleX());
                    txt.fontSize(15);
                }
                txt.fontSize(txt.fontSize() * e.target.scaleX());
                txt.clearCache();
                txt.draw();

                const lineshape: Konva.Line = ng.stage.findOne('.l-' + ng.getMagicStringFromText(e.target.getName()));
                ng.drawLineBetweenRectAndCircle(lineshape);

                lineshape.clearCache();
                lineshape.draw();
            });
        } else if (e.target instanceof Konva.Rect) {
            // e.target.parent.add(tr);
            tr.on('transform', function () {
                ng.checkThatGroupsWithRectStayOnTheStage(e.target.parent, e.target);
                e.target.parent.clearCache();
                e.target.parent.draw();

                const textForRect: Konva.Text = ng.stage.findOne('.tr-' + ng.getMagicStringFromText(e.target.getName()));
                textForRect.x(Number(e.target.x() + 5 * e.target.scaleX()));
                textForRect.y(Number(e.target.y() + 5 * e.target.scaleX()));
                textForRect.fontSize(16 * e.target.scaleX());
                // textForRect.fontSize(textForRect.fontSize() * e.target.scaleX()); // KEVINERIE
                textForRect.width(e.target.width() * e.target.scaleX());
                textForRect.clearCache();
                textForRect.draw();

                const lineshape: Konva.Line = ng.stage.findOne('.l-' + ng.getMagicStringFromText(e.target.getName()));
                ng.drawLineBetweenRectAndCircle(lineshape);
            });
        } else if (e.target instanceof Konva.Text && e.target.getName().startsWith('tc')) {

            // e.target.parent.add(tr);
            // ng.stage.findOne('.c-' + ng.getMagicStringFromText(e.target.getName())).on('transform', function () {
            tr.on('transform', function () {
                ng.checkThatGroupsWithCircleStayOnTheStage(e.target.parent, ng.stage.findOne('.c-' + ng.getMagicStringFromText(e.target.getName())));
                e.target.parent.clearCache();
                e.target.parent.draw();
                const txt: Konva.Text = ng.stage.findOne('.tc-' + ng.getMagicStringFromText(e.target.getName()));

                if (txt.text().length === 1) {
                    txt.x(ng.stage.findOne('.c-' + ng.getMagicStringFromText(e.target.getName())).x() - 5 * ng.stage.findOne('.c-' + ng.getMagicStringFromText(e.target.getName())).scaleX());
                    txt.y(ng.stage.findOne('.c-' + ng.getMagicStringFromText(e.target.getName())).y() - 5 * ng.stage.findOne('.c-' + ng.getMagicStringFromText(e.target.getName())).scaleX());
                    txt.fontSize(16);
                } else {
                    txt.x(ng.stage.findOne('.c-' + ng.getMagicStringFromText(e.target.getName())).x() - 14 * ng.stage.findOne('.c-' + ng.getMagicStringFromText(e.target.getName())).scaleX());
                    txt.y(ng.stage.findOne('.c-' + ng.getMagicStringFromText(e.target.getName())).y() - 5 * ng.stage.findOne('.c-' + ng.getMagicStringFromText(e.target.getName())).scaleX());
                    txt.fontSize(15);
                }

                txt.fontSize(txt.fontSize() * ng.stage.findOne('.c-' + ng.getMagicStringFromText(e.target.getName())).scaleX());
                txt.clearCache();
                txt.draw();

                const lineshape: Konva.Line = ng.stage.findOne('.l-' + ng.getMagicStringFromText(e.target.getName()));
                ng.drawLineBetweenRectAndCircle(lineshape);
            });
        } else if (e.target instanceof Konva.Text && e.target.getName().startsWith('tr')) {
            // e.target.parent.add(tr);
            const rect = ng.stage.findOne('.r-' + ng.getMagicStringFromText(e.target.getName()));
            tr.on('transform', function () {

                const textForRect: Konva.Text = ng.stage.findOne('.tr-' + ng.getMagicStringFromText(e.target.getName()));
                textForRect.fontSize(12);
                textForRect.fontSize(textForRect.fontSize() * ng.stage.findOne('.tr-' + ng.getMagicStringFromText(e.target.getName())).scaleX());
                textForRect.width(rect.width() * rect.scaleX());
                textForRect.clearCache();
                textForRect.draw();

                const lineshape: Konva.Line = ng.stage.findOne('.l-' + ng.getMagicStringFromText(e.target.getName()));
                ng.drawLineBetweenRectAndCircle(lineshape);
            });
        } else if (e.target instanceof Konva.Text && e.target.getName().startsWith('MTR')) {
            const rect = ng.stage.findOne('.r-' + ng.getMagicStringFromText(e.target.getName()));
            tr.on('transform', function () {

                const textForRect: Konva.Text = e.target;
                textForRect.fontSize(14);
                textForRect.fontSize(textForRect.fontSize() * textForRect.scaleX());
                // textForRect.width(rect.width() * rect.scaleX());
                textForRect.clearCache();
                textForRect.draw();

                // const lineshape: Konva.Line = ng.stage.findOne('.l-' + ng.getMagicStringFromText(e.target.getName()));
                // ng.drawLineBetweenRectAndCircle(lineshape);
            })
        }
        else if (e.target instanceof Konva.Image && e.target.getName() === 'Wind-Arrow') {
            tr.on('transform', function () {

                ng.checkThatShapeStayOnTheStage(e.target);
                e.target.parent.clearCache();
                e.target.parent.draw();

                const textForRect: Konva.Text = ng.stage.findOne('.tr-' + ng.getMagicStringFromText(e.target.getName()));
            });
        }
        // if (e.target instanceof Konva.Text && e.target.getName().startsWith('tc')) {
        //     tr.nodes().push(ng.stage.findOne('.c-' + ng.getMagicStringFromText(e.target.getName())));
        // } else if (e.target instanceof Konva.Text && e.target.getName().startsWith('tr')) {
        //     tr.nodes().push(ng.stage.findOne('.r-' + ng.getMagicStringFromText(e.target.getName())));
        // } else {
        //     tr.nodes([e.target]);
        // }

        ng.layer.draw();
        ng.selectedShape = e.target;

    }

    setDragStartEvent() {

        this.stage.on('dragstart', function (e) {
            this.container().style.cursor = 'move';

            const shape = e.target;
            if ((shape instanceof Konva.Transformer)) {
                return;
            }

            e.evt.cancelBubble = true;
            e.evt.stopImmediatePropagation();
            e.evt.stopPropagation();
            if (!(e.evt instanceof TouchEvent)) {
                e.evt.preventDefault();
            }

            // if ((shape instanceof Konva.Text)) {
            //   return;
            // }

            shape.clearCache();

            shape.moveTo(this.children![1]);
            const tr = ng.stage.findOne('Transformer');
            if (tr && !(shape instanceof Konva.Group)) {
                (tr as any).moveTo(this.children![1]);
            }

            this.children![0].draw();
            this.children![1].draw();
            return false;
        });
    }

    setDragEndEvent() {
        // DOC: this -> stage in the event listener
        this.stage.on('dragend', function (e) {
            // document.body.style.cursor = 'default';
            this.container().style.cursor = 'default';

            e.evt.cancelBubble = true;
            e.evt.stopImmediatePropagation();
            e.evt.stopPropagation();
            e.evt.preventDefault();

            const shape: any = e.target;

            // if ((shape instanceof Konva.Text)) {
            //   return;
            // }

            shape.moveTo(this.children![0]);
            if (shape.name() === 'background') {
                shape.moveToBottom();
            }

            if (shape.name() === 'Move-Arrow') {
                shape.moveToBottom();
                shape.moveUp();
            }

            const lineshape: Konva.Line = this.findOne('.l-' + ng.getMagicStringFromText(shape.name()));
            if ((shape instanceof Konva.Group && !(shape instanceof Konva.Transformer))) {
                if (shape.children![0] instanceof Konva.Circle) {
                    const circ: Konva.Circle = this.findOne('.c-' + ng.getMagicStringFromText(shape.name()));
                    ng.checkThatGroupsWithCircleStayOnTheStage(shape, circ);
                } else if (shape.children![0] instanceof Konva.Rect) {
                    const rect: Konva.Rect = this.findOne('.r-' + ng.getMagicStringFromText(shape.name()));
                    ng.checkThatGroupsWithRectStayOnTheStage(shape, rect);
                    if (shape.children?.find(x => x instanceof Konva.Label)) {
                        ng.addToolTipForCancelledMeasure(rect);
                    }
                }
                if (!ng.HasLingetteOrMassif) {
                    ng.drawLineBetweenRectAndCircle(lineshape);
                }

            } else if (shape instanceof Konva.Image) {
                ng.checkThatShapeStayOnTheStage(shape);
            } else if (shape instanceof Konva.Text) {
                ng.checkThatTextStayOnTheStage(shape);
            } else if (shape instanceof Konva.Rect) {
                ng.checkThatShapeStayOnTheStage(shape);
                ng.drawLineBetweenRectAndCircle(lineshape);
                ng.addToolTipForCancelledMeasure(shape);
            } else {
                ng.checkThatShapeStayOnTheStage(shape);
            }

            shape.clearCache();

            this.children![0].draw();
            this.children![1].draw();

            return false;
        });
    }

    drawLineBetweenRectAndCircle(line: Konva.Line) {
        const uniqueCode = ng.getMagicStringFromText(line.name());
        line.points([
            Number(ng.stage.findOne(`.gc-${uniqueCode}`).x()) + Number(ng.stage.findOne(`.c-${uniqueCode}`).x()),
            Number(ng.stage.findOne(`.gc-${uniqueCode}`).y()) + Number(ng.stage.findOne(`.c-${uniqueCode}`).y()),
            Number(ng.stage.findOne(`.gr-${uniqueCode}`).x()) + Number(ng.stage.findOne(`.r-${uniqueCode}`).x()) + ng.rectDefaultWidth * ng.stage.findOne(`.r-${uniqueCode}`).scaleX() / 2,
            Number(ng.stage.findOne(`.gr-${uniqueCode}`).y()) + Number(ng.stage.findOne(`.r-${uniqueCode}`).y()) + ng.rectDefaultHeight * ng.stage.findOne(`.r-${uniqueCode}`).scaleY() / 2]);

        // line.duration = 0;
        // line.easing = Konva.Easings.ElasticEaseOut;

        line.clearCache();
        line.draw();
    }

    checkThatShapeStayOnTheStage(shape: Konva.Shape) {

        if (shape instanceof Konva.Transformer) {
            return;
        }
        // ROTATED SHAPE
        // HG => HG pas de rot
        // BD => Bas Droite
        // HG => Haut Droite
        // BG => Bas Gauche
        if (shape.name() === 'Wind-Arrow') {
            const r = shape.width() / 2;

            const co = shape.getAbsolutePosition(this.stage);

            const rcos = Math.cos((Konva as any).getAngle(shape.rotation()));
            const rsin = Math.sin((Konva as any).getAngle(shape.rotation()));

            const xO = shape.x()//(shape.x() - this.rectOriginX) * rcos2 - (shape.y() - this.rectOriginY) * rsin2 //shape.getAbsolutePosition(this.stage).x + shape.width() / 2;
            const yO = shape.y()//(shape.x() - this.rectOriginX) * rsin2 + (shape.y() - this.rectOriginY) * rcos2 //shape.getAbsolutePosition(this.stage).y + shape.width() / 2;

            const xM_HD = xO + shape.width();
            const yM_HD = yO;
            const xM_BD = xO + shape.width();
            const yM_BD = yO + shape.width();
            const xM_BG = xO;
            const yM_BG = yO + shape.width();

            // var greenLine = new Konva.Line({
            //     points: [xM_HD, yM_HD, xM_HD, yM_HD],
            //     stroke: 'green',
            //     strokeWidth: 5,
            //     lineCap: 'round',
            //     lineJoin: 'round',
            // });

            // var redLine = new Konva.Line({
            //     points: [xO, yO, xO, yO],
            //     stroke: 'red',
            //     strokeWidth: 5,
            //     lineCap: 'round',
            //     lineJoin: 'round',
            // });

            // var blueLine = new Konva.Line({
            //     points: [(xM_HD - xO) * rcos - (yM_HD - yO) * rsin + xO,
            //     (xM_HD - xO) * rsin + (yM_HD - yO) * rcos + yO,
            //     (xM_HD - xO) * rcos - (yM_HD - yO) * rsin + xO,
            //     (xM_HD - xO) * rsin + (yM_HD - yO) * rcos + yO],
            //     stroke: 'blue',
            //     strokeWidth: 5,
            //     lineCap: 'round',
            //     lineJoin: 'round',
            // });

            // var yellowLine = new Konva.Line({
            //     points: [(xM_BD - xO) * rcos - (yM_BD - yO) * rsin + xO,
            //     (xM_BD - xO) * rsin + (yM_BD - yO) * rcos + yO,
            //     (xM_BD - xO) * rcos - (yM_BD - yO) * rsin + xO,
            //     (xM_BD - xO) * rsin + (yM_BD - yO) * rcos + yO],
            //     stroke: 'yellow',
            //     strokeWidth: 5,
            //     lineCap: 'round',
            //     lineJoin: 'round',
            // });

            // var pinkLine = new Konva.Line({
            //     points: [(xM_BG - xO) * rcos - (yM_BG - yO) * rsin + xO,
            //     (xM_BG - xO) * rsin + (yM_BG - yO) * rcos + yO,
            //     (xM_BG - xO) * rcos - (yM_BG - yO) * rsin + xO,
            //     (xM_BG - xO) * rsin + (yM_BG - yO) * rcos + yO],
            //     stroke: 'pink',
            //     strokeWidth: 5,
            //     lineCap: 'round',
            //     lineJoin: 'round',
            // });
            // this.layer.add(pinkLine);
            // this.layer.add(yellowLine);
            // this.layer.add(blueLine);
            // this.layer.add(greenLine);
            // this.layer.add(redLine);
            // redLine.moveToTop()
            // greenLine.moveToTop()
            // this.layer.draw();

            this.checkPointOnScene(
                shape,
                shape.x(),
                shape.y());
            this.checkPointOnScene(
                shape,
                (xM_HD - xO) * rcos - (yM_HD - yO) * rsin + xO,
                (xM_HD - xO) * rsin + (yM_HD - yO) * rcos + yO);
            this.checkPointOnScene(
                shape,
                (xM_BD - xO) * rcos - (yM_BD - yO) * rsin + xO,
                (xM_BD - xO) * rsin + (yM_BD - yO) * rcos + yO);
            this.checkPointOnScene(
                shape,
                (xM_BG - xO) * rcos - (yM_BG - yO) * rsin + xO,
                (xM_BG - xO) * rsin + (yM_BG - yO) * rcos + yO);

        } else {
            if (shape.x() < 0) {
                shape.x(0);
            }
            if (shape.y() < 0) {
                shape.y(0);
            }
            if (shape.x() + shape.width() * shape.scaleX() > this.sceneWidth) {
                shape.x(this.sceneWidth - shape.width() * shape.scaleX());
            }
            if (shape.y() + shape.height() * shape.scaleY() > this.sceneHeight) {
                shape.y(this.sceneHeight - shape.height() * shape.scaleY());
            }
        }
    }

    private checkPointOnScene(shape: Konva.Shape, x: number, y: number) {
        if (x < 0) {
            shape.x(shape.x() - x)
        }
        if (x > this.sceneWidth) {
            shape.x(shape.x() - (x - this.sceneWidth));
        }

        if (y < 0) {
            shape.y(shape.y() - y)
        }
        if (y > this.sceneHeight) {
            shape.y(shape.y() - (y - this.sceneHeight));
        }
    }

    private rotatePoint = (x: number, y: number, r: number, rad: number) => {
        const rcos = Math.cos(rad);
        const rsin = Math.sin(rad);
        return { d1: x * rcos - y * rsin, d2: y * rcos + x * rsin };
    }

    private haveIntersection(stage: Konva.Stage, image: Konva.Shape) {
        return !(
            image.x() > stage.x() + stage.width() ||
            image.x() + image.width() < stage.x() ||
            image.y() > stage.y() + stage.height() ||
            image.y() + image.height() < stage.y()
        );
    }

    checkThatTextStayOnTheStage(shape: Konva.Text) {
        const rotated = this.rotatePoint(shape.x(), shape.y(), shape.getTextWidth(), (Konva as any).getAngle(shape.rotation())); // TODO any works ?

        if (shape.x() < 5) {
            shape.x(5);
        }
        if (shape.y() < 5) {
            shape.y(5);
        }

        if (shape.y() + rotated.d2 < 5) {
            shape.y(5 - rotated.d2);
        }
        if (shape.x() + rotated.d1 < 5) {
            shape.x(5 - rotated.d1);
        }

        if (shape.x() * this.stage.scaleX() > this.sceneWidth) {
            shape.x(this.sceneWidth);
        }
        if (shape.y() * this.stage.scaleY() > this.sceneHeight) {
            shape.y(this.sceneHeight);
        }

        if (shape.x() * this.stage.scaleX() + rotated.d1 > this.sceneWidth) {
            shape.x(this.sceneWidth - rotated.d1);
        }
        if (shape.y() * this.stage.scaleY() + rotated.d2 > this.sceneHeight) {
            shape.y(this.sceneHeight - rotated.d2);
        }
    }

    /**
     * @param group 
     * @param circ 
     */
    checkThatGroupsWithCircleStayOnTheStage(group: Konva.Group, circ: Konva.Circle) {
        if (group.x() + circ.x() - circ.radius() * circ.scaleX() < 0) {
            group.x(circ.radius() * circ.scaleX() - circ.x());
        }
        if (group.y() + circ.y() - circ.radius() * circ.scaleY() < 0) {
            group.y(circ.radius() * circ.scaleY() - circ.y());
        }
        if (group.x() + circ.x() + circ.radius() * group.scaleX() * circ.scaleX() + circ.strokeWidth() > this.sceneWidth) {
            group.x(this.sceneWidth - circ.radius() * group.scaleX() * circ.scaleX() - circ.x() - circ.strokeWidth());
        }
        if (group.y() + circ.y() + circ.radius() * group.scaleY() * circ.scaleY() + circ.strokeWidth() > this.sceneHeight) {
            group.y(this.sceneHeight - circ.radius() * group.scaleY() * circ.scaleY() - circ.y() - circ.strokeWidth());
        }
    }

    checkThatGroupsWithRectStayOnTheStage(group: Konva.Group, rect: Konva.Rect) {
        if (group.x() + rect.x() < 0) {
            group.x(-rect.x());
        }
        if (group.y() + rect.y() < 0) {
            group.y(-rect.y());
        }
        if (group.x() + rect.width() * group.scaleX() * rect.scaleX() + rect.x() + rect.strokeWidth() > this.sceneWidth) {
            group.x(this.sceneWidth - rect.width() * group.scaleX() * rect.scaleX() - rect.x() - rect.strokeWidth());
        }
        if (group.y() + rect.height() * group.scaleY() * rect.scaleY() + rect.y() + rect.strokeWidth() > this.sceneHeight) {
            group.y(this.sceneHeight - rect.height() * group.scaleY() * rect.scaleY() - rect.y() - rect.strokeWidth());
        }
    }

    dataURLtoFile(dataurl: string, filename: string) {
        const arr = dataurl.split(',');
        if (!arr || !arr[0]) {
            return;
        }
        const mime = arr[0].match(/:(.*?);/)![1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }

    onDrop(event: DndDropEvent) {
        if (typeof event.data !== 'string') {
            return;
        }
        const measure = this.LingetteOrMassifList.find(x => x.Code === event.data);
        if (!measure) {
            return;
        }
        this.addBubleToTheStage(measure, event.event.clientX + event.event.offsetX, event.event.clientY + event.event.offsetY);
    }

    getMagicString(measure: MeasureLingette | MeasureMassif) {
        return `${measure instanceof MeasureLingette ? 'LING' : 'MASS'}-${measure.Code}-${measure.Position}`;
    }

    async addBubleToTheStage(measure: MeasureLingette | MeasureMassif, x: number, y: number) {

        let circ = null;
        let text = null;

        const groupForCircle = new Konva.Group({
            x: x,
            y: y,
            draggable: true,
            name: `gc-${this.getMagicString(measure)}`,
            stroke: 'green',
            strokeWidth: 1,
            fill: 'blue'
        });

        circ = new Konva.Circle({
            x: 1,
            y: 1,
            name: `c-${this.getMagicString(measure)}`,
            radius: 30,
            fill: 'pink',
            stroke: 'black',
            strokeWidth: 1,
        });

        text = new Konva.Text({
            x: measure.Position > 9 ? -16 : - 7,
            y: - 12,
            text: `${measure.Position}`,
            name: `tc-${this.getMagicString(measure)}`,
            fontStyle: 'bold',
            fontSize: 32
        });

        groupForCircle.add(circ);
        groupForCircle.add(text);
        this.layer.add(groupForCircle);

        this.checkThatGroupsWithCircleStayOnTheStage(groupForCircle, circ);

        this.layer.draw();

        // if (!_.includes(['I', 'J', 'K'], measure.ChipName)) {
        // _.remove(this.AvailableMeasures, measure);
        // this.refreshFilteredMeasures();
        // this.Model.Measures.push(measure);
        // }

        this.updateMeasureStatus(measure, ELifeCycleStatus.CompletedAndPositionedNotSaved);

        this.setLinesTransformer();
    }

    async removeLingette() {

        let lingetteOrMassif = this.LingetteOrMassifList.find(l => l.Position === Number(this.SelectedLingetteOrMassifPosition))!;
        lingetteOrMassif!.Status = ELifeCycleStatus.CompletedAndNotPositioned;
        if (lingetteOrMassif instanceof MeasureLingette) {
            await db.measureLingetteRepository.updateMeasureLingette(lingetteOrMassif!);
            this.LingetteOrMassifList = (await db.getInterventionByCode(this.interventionCode)).MesureLingetteList;
        }
        if (lingetteOrMassif instanceof MeasureMassif) {
            await db.measureMassifRepository.updateMeasureMassif(lingetteOrMassif!);
            this.LingetteOrMassifList = (await db.getInterventionByCode(this.interventionCode)).MesureMassifList;
        }

        const group = this.layer.findOne((node: Konva.Node) => node instanceof Konva.Group && node.name().startsWith(`gc-${lingetteOrMassif instanceof MeasureLingette ? 'LING' : 'MASS'}-${lingetteOrMassif.Code}-${lingetteOrMassif.Position}`));
        group.destroy();
        this.stage.findOne((node: Konva.Shape) => node instanceof Konva.Transformer)?.destroy();
        this.layer.draw();

        this.SelectedLingetteOrMassifPosition = undefined;
    }

    addGAXISpecificThumbnail() {
        const imageObj = new Image();
        imageObj.src = `${PathUtility.getUriPath()}/../assets/GAX-specific-thumbnail/GAX-I.jpg`;
        imageObj.onload = function () {
            const img: Konva.Image = ng.stage.findOne((node: Konva.Shape) => node instanceof Konva.Image && node.name() === ng.GAX_I);
            img.image(imageObj);
            img.width(imageObj.width);
            img.height(imageObj.height);
            // img.used(true);
            img.draw();
            ng.layer.draw();
        };
    }

    addGAXJSpecificThumbnail() {
        const imageObj = new Image();
        imageObj.src = `${PathUtility.getUriPath()}/../assets/GAX-specific-thumbnail/GAX-J.jpg`;
        imageObj.onload = function () {
            const img: Konva.Image = ng.stage.findOne((node: Konva.Shape) => node instanceof Konva.Image && node.name() === ng.GAX_J);
            img.image(imageObj);
            img.width(imageObj.width);
            img.height(imageObj.height);
            // img.used(true);
            img.draw();
            ng.layer.draw();
        };
    }

    addGAXKSpecificThumbnail() {
        const imageObj = new Image();
        imageObj.src = `${PathUtility.getUriPath()}.location.href}/../assets/GAX-specific-thumbnail/GAX-K.jpg`;
        imageObj.onload = function () {
            const img: Konva.Image = ng.stage.findOne((node: Konva.Shape) => node instanceof Konva.Image && node.name() === ng.GAX_K);
            img.image(imageObj);
            img.width(imageObj.width);
            img.height(imageObj.height);
            // img.used(true);
            img.draw();
            ng.layer.draw();
        };
    }

    attachImageToHachure() {
        const imageObj = new Image();
        imageObj.src = `${PathUtility.getUriPath()}.location.href}/../assets/hachure.png`;
        imageObj.onload = function () {
            const img: Konva.Image = ng.stage.findOne((node: Konva.Shape) => node instanceof Konva.Image && node.name() === 'Move-Arrow');
            img.image(imageObj);
            img.width(imageObj.width);
            img.height(imageObj.height);
            // img.used(true);
            img.draw();
            ng.layer.draw();
        };
    }

    attachImageToWind() {
        const imageObj = new Image();
        imageObj.src = `${PathUtility.getUriPath()}/../assets/right-arrow.png`;
        imageObj.onload = function () {
            const img: Konva.Image = ng.stage.findOne((node: Konva.Shape) => node instanceof Konva.Image && node.name() === 'Wind-Arrow');
            img.image(imageObj);
            img.width(imageObj.width);
            img.height(imageObj.height);
            // img.used(true);
            img.draw();
            ng.layer.draw();
        };
    }

    addWindThumbnail() {

        // this.layer.add(imgWind);

        const imageObj = new Image();
        imageObj.src = `${PathUtility.getUriPath()}/../assets/wind-thumbnail.png`;
        // imageObj.src = `${(this.platformLocation as any).location.href}/../assets/icons/wind-thumbnail.png`;
        imageObj.onload = function () {
            const img: Konva.Image = ng.stage.findOne((node: Konva.Shape) => node instanceof Konva.Image && node.name() === ng.IMG_WIND);
            if (img) {

                img.image(imageObj);
                // img.used(true);
                img.width(imageObj.width);
                img.height(imageObj.height);
                img.draw();
            } else {

                const imgWind = new Konva.Image({
                    x: ng.sceneWidth / 2 - 180 / 2,
                    y: ng.sceneHeight - 160,
                    name: ng.IMG_WIND,
                    draggable: true,
                    image: imageObj
                });
                ng.layer.add(imgWind);
                imgWind.moveToTop();
            }
            ng.layer.draw();
        };
    }

    canAddWindArrow() {
        return !this.stage.findOne('.Wind-Arrow');
    }

    deleteWindArrow() {
        this.stage.findOne((node: Konva.Shape) => node instanceof Konva.Transformer)?.destroy();
        this.stage.findOne('.Wind-Arrow').destroy();
        this.stage.draw();
    }

    addWindArrow() {

        const imgWind = new Konva.Image({
            x: this.sceneWidth / 2 - 180,
            y: this.sceneHeight - 110,
            name: 'Wind-Arrow',
            draggable: true,
            image: undefined
        });

        this.layer.add(imgWind);

        const imageObj = new Image();
        imageObj.src = `${PathUtility.getUriPath()}/../assets/right-arrow.png`;
        imageObj.onload = function () {
            const img: Konva.Image = ng.stage.findOne((node: Konva.Shape) => node instanceof Konva.Image && node.name() === 'Wind-Arrow');
            img.image(imageObj);
            img.width(imageObj.width);
            img.height(imageObj.height);
            // img.used(true);
            img.draw();
            ng.layer.draw();
            ng.setLinesTransformer();
        };
    }

    canAddMoveArrow() {
        return !this.stage.findOne('.Move-Arrow');
    }

    deleteMoveArrow() {
        this.stage.findOne('.Move-Arrow').destroy();
        this.stage.draw();
    }

    addMoveArrow() {
        const imgWind = new Konva.Image({
            x: this.sceneWidth / 2,
            y: this.sceneHeight / 2,
            name: 'Move-Arrow',
            draggable: true,
            image: undefined
        });

        this.layer.add(imgWind);

        const imageObj = new Image();
        imageObj.src = `${PathUtility.getUriPath()}/../assets/hachure.png`;
        imageObj.onload = function () {
            const img: Konva.Image = ng.stage.findOne((node: Konva.Shape) => node instanceof Konva.Image && node.name() === 'Move-Arrow');
            img.image(imageObj);
            img.width(imageObj.width);
            img.height(imageObj.height);
            // img.used(true);
            img.draw();
            ng.layer.draw();
            ng.setLinesTransformer();
        };
    }

    /// TEXT EDITION

    setTextTransform(textNode: Konva.Text) {

        textNode.on('transform', function () {
            // reset scale, so only with is changing by transformer
            textNode.setAttrs({
                width: textNode.width() * textNode.scaleX(),
                scaleX: 1
            });

            ng.checkThatTextStayOnTheStage(textNode);
        });
    }

    updateMeasureStatus = async (measure: MeasureLingette | MeasureMassif, status: ELifeCycleStatus) => {
        measure.Status = status;

        if (measure instanceof MeasureLingette) {
            await db.measureLingetteRepository.updateMeasureLingette(measure);
            this.LingetteOrMassifList = (await db.getInterventionByCode(this.interventionCode)).MesureLingetteList;
        }
        if (measure instanceof MeasureMassif) {
            await db.measureMassifRepository.updateMeasureMassif(measure);
            this.LingetteOrMassifList = (await db.getInterventionByCode(this.interventionCode)).MesureMassifList;
        }
    }

    get CanSave() {
        if (this.HasLingetteOrMassif) {
            return true;
        }
        return !this.IsProcess || (this.IsProcess && this.stage.findOne('.Move-Arrow'));
    }

    navigateBack() {
        this.router.navigate([ENavigationRoute.Intervention, { interventionCode: this.interventionCode }]);
    }

    saveMap() {
        (ng.stage.findOne('Transformer') as any)?.destroy();
        // this.Model.JsonContent = this.stage.toJSON();

        const groups = this.layer.find((node: Konva.Node) => node instanceof Konva.Group && (node.name().startsWith(`gc-LING`) || node.name().startsWith(`gc-MASS`)));
        groups.forEach(async (group: Konva.Node) => {
            const name = group.name();
            if (name) {
                const [, type, code, position] = name.match(/^gc-(LING|MASS)-(.+)-(\d+)$/) ?? [];
                const measure = this.LingetteOrMassifList.find(m =>
                    m.Code === code &&
                    m.Position === Number(position))
       
                if (measure) {
                    await ng.updateMeasureStatus(measure, ELifeCycleStatus.CompletedAndPositioned);
                }
            }
        });

        const scale = window.devicePixelRatio;
        const img = this.stage.toImage({
            quality: 0,
            pixelRatio: 3,
            async callback(imageObj) {

                // ng.Model.Data = ng.dataURLtoFile(imageObj.src, `${ng.Model.Legend}.png`) as any;
                // ng.Model.Data = imageObj.src;
                await db.updateAreaMap(ng.areaMapLocalId, ng.stage.toJSON(), imageObj.src)
                ng.navigateBack();
            }
        });
    }

}
